module.exports = __webpack_public_path__ + "media/components/riskregister/icons/product-fc3a512804855ad684057abb5ee9ec13.png";